import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createStore } from "redux";
import { Provider } from "react-redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { PersistGate } from "redux-persist/integration/react";
import allReducers from "./Redux/Reducers/Index";
import {PublicClientApplication, EventType} from "@azure/msal-browser"

const pca = new PublicClientApplication({
  auth: {
    clientId: "a0b6e0f0-3629-4e52-ba99-66997c0e9ea2",
    authority: "https://login.microsoftonline.com/b841de22-e0c3-40c5-b3fe-c287594b4649",
    redirectUri: "/"
  }
});

pca.addEventCallback(event => {
  if(event.eventType === EventType.LOGIN_SUCCESS){
    console.log("event", event);
    pca.setActiveAccount(event.payload.account)
    localStorage.setItem("accessToken", event.payload.accessToken)
  }
})

const persistConfig = {
  key: "Todo",
  storage,
  whitelist: ["myTodo"], // only navigation will be persisted
};

const persistedReducer = persistReducer(persistConfig, allReducers);

const store = createStore(persistedReducer);

const persistor = persistStore(store);

store.subscribe(() => console.log(store.getState()));

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App msalInstance={pca} />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
